import React from "react";
import {
  ServicesContainer,
  ServicesH1,
  ServicesWrapper,
  ServicesCard,
  ServicesIcon,
  ServicesH2,
  ServicesP,
  ServicesSpan,
} from "./ServicesElements";
import Rabbit from "../../images/grupa-iepurasilor.png";
import Dogs from "../../images/grupa-catelusilor.png";

const Services = () => {
  return (
    <ServicesContainer id="groups">
      <ServicesH1>Grupele noastre</ServicesH1>
      <ServicesWrapper>
        <ServicesCard>
          <ServicesIcon src={Dogs}></ServicesIcon>
          <ServicesH2>Grupa Mare / Grupa Catelusilor</ServicesH2>
          <ServicesSpan>22 prescolari</ServicesSpan>
          <ServicesP>Educatoare - sora MARIA CHELARU</ServicesP>
        </ServicesCard>
        <ServicesCard>
          <ServicesIcon src={Rabbit}></ServicesIcon>
          <ServicesH2>Grupa Mijlocie / Grupa Iepurasilor</ServicesH2>
          <ServicesSpan>22 prescolari</ServicesSpan>
          <ServicesP>Educatoare - sora MARIA ANTON</ServicesP>
        </ServicesCard>
        {/* <ServicesCard>
          <ServicesIcon src=""></ServicesIcon>
          <ServicesH2>Premium Benefits</ServicesH2>
          <ServicesP>
            Donec sodales sagittis magna. Sed consequat, leo eget bibendum
            sodales, augue velit cursus nunc,
          </ServicesP>
        </ServicesCard> */}
      </ServicesWrapper>
    </ServicesContainer>
  );
};

export default Services;
